<template>
    <v-dialog v-model="dialog"
        fullscreen hide-overlay transition="dialog-bottom-transition"
    >
        <v-card tile class="grey darken-3">
            <v-app-bar dense color="blue-grey darken-2" max-height="48px">
                <v-toolbar-title>Report</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="onReload">
                    <v-icon>mdi-reload</v-icon>
                </v-btn>
            </v-app-bar>
				<v-tabs v-model="htab" background-color="blue-grey darken-3" color="grey" active-class="blue-grey darken-1 black--text"
					align-with-title
					slider-color="blue-grey darken-1"
					dark dense height="35px"
					next-icon="mdi-arrow-right-bold-box-outline"
					prev-icon="mdi-arrow-left-bold-box-outline"
					show-arrows show-arrows-on-hover center-active
				>
					<v-tab v-for="(item, hindex) in days" :key="hindex" height="35px">
						{{ item.name }}
					</v-tab>
				</v-tabs>
                <v-tabs-items v-model="htab" />
            <v-card-text class="ma-0 pa-0" style="xheight: 520px;">
   <v-simple-table dense fixed-header :height="(winHeight - 137) + 'px'" class="grey darken-3">
      <template v-slot:default class="grey darken-3">
        <thead>
          <tr>
            <th class="text-left grey darken-3">Nr</th>
            <th class="text-left grey darken-3">Leistung</th>
            <th class="text-left grey darken-3">Menge</th>
            <th class="text-left grey darken-3">Menge Klfl.</th>
            <th class="text-left grey darken-3">Betrag</th>
            <th class="text-left grey darken-3">Gesamt</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="item in items" :key="item.name" class="ma-0 pa-0 px-0">
            <td class="ma-0 pa-0 pt-1 pl-1" width="20px">
              <v-text-field v-model="item.tsknr" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly
               class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
            </td>
            <td class="ma-0 pa-0 pt-1 pl-1" width="250px">
              <v-text-field v-model="item.tskname" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly
               class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
            </td>
            <td class="ma-0 pa-0 pt-1 pl-1" width="200px">
            <v-fab-transition mode="out-in">
                <v-text-field v-if="htab==0" v-model="item.amount1" label="" hide-details dense placeholder="Mo" solo  key="1"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==1" v-model="item.amount2" label="" hide-details dense placeholder="Di" solo key="2"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==2" v-model="item.amount3" label="" hide-details dense placeholder="Mi" solo key="3"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==3" v-model="item.amount4" label="" hide-details dense placeholder="Do" solo key="4"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==4" v-model="item.amount5" label="" hide-details dense placeholder="Fr" solo key="5"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==5" v-model="item.amount6" label="" hide-details dense placeholder="Sa" solo key="6"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==6" v-model="item.amount7" label="" hide-details dense placeholder="So" solo key="7"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="item.comp + ' € / ' + item.unit"
                ></v-text-field>
            </v-fab-transition>
            </td>
            <td class="ma-0 pa-0 pt-1 pl-1" width="200px">
            <v-fab-transition mode="out-in">
                <v-text-field v-if="htab==0" v-model="item.amount1k" label="" hide-details dense placeholder="Mo" solo key="1"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==1" v-model="item.amount2k" label="" hide-details dense placeholder="Di" solo key="2"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==2" v-model="item.amount3k" label="" hide-details dense placeholder="Mi" solo key="3"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==3" v-model="item.amount4k" label="" hide-details dense placeholder="Do" solo key="4"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==4" v-model="item.amount5k" label="" hide-details dense placeholder="Fr" solo key="5"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==5" v-model="item.amount6k" label="" hide-details dense placeholder="Sa" solo key="6"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
                <v-text-field v-if="htab==6" v-model="item.amount7k" label="" hide-details dense placeholder="So" solo key="7"
                class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                :prefix="(item.compk || '-') + ' € / ' + item.unit"
                ></v-text-field>
            </v-fab-transition>
            </td>
            <td class="ma-0 pa-0 pt-1 pl-1" width="100px">
                <v-fab-transition mode="out-in">
                    <v-text-field v-if="htab==0" v-model="item.sum1" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="1"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    <v-text-field v-if="htab==1" v-model="item.sum2" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="2"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    <v-text-field v-if="htab==2" v-model="item.sum3" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="3"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    <v-text-field v-if="htab==3" v-model="item.sum4" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="4"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    <v-text-field v-if="htab==4" v-model="item.sum5" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="5"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    <v-text-field v-if="htab==5" v-model="item.sum6" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="6"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    <v-text-field v-if="htab==6" v-model="item.sum7" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="7"
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                </v-fab-transition>
            </td>
            <td class="ma-0 pa-0 pt-1 pl-1" width="100px">
                <v-text-field v-model="item.total" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly
                class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
            </td>
            </tr>
            <tr>
                <td colspan="4"></td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="100px">
                    <v-fab-transition mode="out-in">
                        <v-text-field v-if="htab==0" v-model="daysum[1]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="1"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                        <v-text-field v-if="htab==1" v-model="daysum[2]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="2"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                        <v-text-field v-if="htab==2" v-model="daysum[3]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="3"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                        <v-text-field v-if="htab==3" v-model="daysum[4]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="4"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                        <v-text-field v-if="htab==4" v-model="daysum[5]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="5"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                        <v-text-field v-if="htab==5" v-model="daysum[6]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="6"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                        <v-text-field v-if="htab==6" v-model="daysum[7]" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly key="7"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                    </v-fab-transition>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="100px">
                    <v-text-field v-model="totalsum" label="Solo" hide-details dense placeholder="Placeholder" solo spellcheck="false" readonly
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                </td>
            </tr>
        </tbody>
      </template>
    </v-simple-table>
            </v-card-text>
            <v-divider />
            <v-card-actions>
            <v-btn text class="warning" @click="onCancel()">Abbrechen</v-btn>
            <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	export default {
	  	name: 'report',
		components: {},
        props: {
            specData: {
                type: Object,
                required: true,
                default: null,
            },
        },
		data: () => ({
            loading: false,
            dialog: false,
            search: '',
            htab: 0,
            winHeight: window.innerHeight,
            days: [
                { name: 'Mo'}, { name: 'Di'}, { name: 'Mi'}, { name: 'Do'}, { name: 'Fr'}, { name: 'Sa'}, { name: 'So'}, 
            ],
            items: [],
            daysum: [0, 0, 0, 0, 0, 0, 0, 0],
            totalsum: 0,
        }),
        computed: {
            report() {
                return this.specData.meta.model
            }
        },
		methods: {
            async editData() {
                this.loading = true
                const param = {
                    tablename: 'reports',
                    subtable: 'repitems',
                    data: this.report
                }
                try {
                    await this.$store.dispatch('special/editSubItems', param)
                    this.items = Object.assign([], this.$store.getters['special/getItem'])
                    this.calcDaySum()
                    console.log(this.items)
                    this.dirty = false
                } catch (error) {
                    console.error(error)
                } finally {
                    this.loading = false
                }
            },
            calcDaySum() {
                this.items.map(e => e.sum1 = e.amount1 * e.comp + e.amount1k * e.compk)
                this.items.map(e => e.sum2 = e.amount2 * e.comp + e.amount2k * e.compk)
                this.items.map(e => e.sum3 = e.amount3 * e.comp + e.amount3k * e.compk)
                this.items.map(e => e.sum4 = e.amount4 * e.comp + e.amount4k * e.compk)
                this.items.map(e => e.sum5 = e.amount5 * e.comp + e.amount5k * e.compk)
                this.items.map(e => e.sum6 = e.amount6 * e.comp + e.amount6k * e.compk)
                this.items.map(e => e.sum7 = e.amount7 * e.comp + e.amount7k * e.compk)
                this.daysum[1] = this.items.reduce(function(prev, cur) { return prev + cur.sum1; }, 0);
                this.daysum[2] = this.items.reduce(function(prev, cur) { return prev + cur.sum2; }, 0);
                this.daysum[3] = this.items.reduce(function(prev, cur) { return prev + cur.sum3; }, 0);
                this.daysum[4] = this.items.reduce(function(prev, cur) { return prev + cur.sum4; }, 0);
                this.daysum[5] = this.items.reduce(function(prev, cur) { return prev + cur.sum5; }, 0);
                this.daysum[6] = this.items.reduce(function(prev, cur) { return prev + cur.sum6; }, 0);
                this.daysum[7] = this.items.reduce(function(prev, cur) { return prev + cur.sum7; }, 0);
                this.totalsum = this.items.reduce(function(prev, cur) {
                    return prev + cur.sum1 + cur.sum2 + cur.sum3 + cur.sum4 + cur.sum5 + cur.sum6 + cur.sum7;
                }, 0);
            },
            onReload() {
                this.editData()
            },
            onCancel() {
                this.$emit('cancel')
                this.dialog = false
            },
            onSubmit() {
                this.$emit('submit')
                this.dialog = false
            },
            handleResize() {
                this.winHeight = window.innerHeight
            },
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
		mounted() {
            console.log('dialog report mounted')
            this.editData()
            this.dialog = true
        },
        beforeDestroy() {
            console.log('destroying dialog report')
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
	  	watch: {
        },
    }
</script>
<style scoped>
.v-data-table td {
  border: none !important;
}

.v-data-table >>> tbody tr:hover {
  background: transparent !important;
}

.textfield >>> .v-text-field__slot input {
    color: orange;
}
.textfield >>> .v-text-field__slot input:focus {
    color: orange;
}
.textfield >>> .v-text-field__slot input::placeholder {
    color: #424242;
}
.right-aligned >>> input {
    text-align: end;
}
.textfield >>> .v-text-field__prefix {
    color: black;
}

</style>